
$(document).ready(function(){
    console.log('Quiz tracking setup launched! Ready to send events');

    function sendGAEvent(eventName, eventLabel) {
        if (!sessionStorage.getItem(eventName)) {
            gtag('event', eventName, {
                'event_category': 'User Actions',
                'event_label': eventLabel,
                'value': 1
            });

            console.log(`${eventName} - Sent`);
            sessionStorage.setItem(eventName, "true"); // Store in sessionStorage
        } else {
            console.log(`${eventName} - Already Sent (Skipping)`);
        }
    }

    // Button Click Events
    $(document).on("click",".qz_start_atc_cont", function() {
        sendGAEvent('Quiz_started', 'Quiz button');
    });

    $(document).on("click",".qz_start_atc_cont a", function() {
        sendGAEvent('Quiz_started', 'Quiz button');
    });


    // Quiz Question Events
    for (let i = 1; i <= 16; i++) {
        $(document).on("click", `#GtmQuiz_${i}`, function() {
            sendGAEvent(`Quiz_passed_question_${i}`, 'Quiz button');
        });
    }

    // Page View Events
    var currentLocation = String(window.location.href);

    if (currentLocation.includes('quiz-results')) {
        sendGAEvent('Quiz_viewed_results_step', 'Quiz button');
    }

    if (currentLocation.includes('quiz-offer')) {
        sendGAEvent('Quiz_viewed_offer_step', 'Quiz button');
    }
});
